/**
 * The zone bosses' stat blocks (ADR 0024), read by `mobs.ts` with the rest
 * of the bestiary; what they do besides biting is in `bosses.ts`.
 *
 * Set by hand against a Warrior at the top of the biome's band in its rare
 * set at +3 with a tenth more damage to bosses, what the players met in the
 * beta wore (ADR 0088): about ninety seconds alone, the scarecrow a little
 * less as the first lesson. Its marks on the ground take a share of health
 * (`abilityDamage`), so the fight is dodged, not tanked. Level three over
 * the band, like the biome's legendary elite, which it outlasts and outhits.
 */
export const BOSS_MOB_IDS = [
    'great-scarecrow',
    'werewolf',
    'bog-troll',
    'golden-jackal',
    'frost-giant',
];
/**
 * A minute, fixed (ADR 0090): a fight lost is retried at once, and nobody
 * waits for a boss someone else just felled. Its loot is the day's, once
 * per character, so its pace no longer sets how much it hands out.
 */
export const BOSS_RESPAWN_MS = 60_000;
/** What every boss shares: it holds its arena and never strolls out of it. */
const BOSS = {
    rank: 'zone-boss',
    aggroRange: 5,
    // The arena's radius and one more: pulled further, it gives up and heals.
    leashRange: 7,
    respawnMs: BOSS_RESPAWN_MS,
    wanderRadius: 1,
    restMs: 6000,
    // No table of its own: its loot is `rollBossLoot`.
    loot: [],
};
export const BOSS_DEFINITIONS = {
    'great-scarecrow': {
        ...BOSS,
        id: 'great-scarecrow',
        name: 'Grand Épouvantail',
        bodyKey: 'body.great-scarecrow',
        tilesPerSecond: 3,
        health: 2200,
        damage: 12,
        attackIntervalMs: 1600,
        xp: 600,
        level: 7,
    },
    werewolf: {
        ...BOSS,
        id: 'werewolf',
        name: 'Loup-Garou',
        bodyKey: 'body.werewolf',
        tilesPerSecond: 4,
        health: 3800,
        damage: 16,
        attackIntervalMs: 1400,
        xp: 900,
        level: 10,
    },
    'bog-troll': {
        ...BOSS,
        id: 'bog-troll',
        name: 'Troll des Tourbières',
        bodyKey: 'body.bog-troll',
        tilesPerSecond: 2.5,
        health: 4700,
        damage: 22,
        attackIntervalMs: 1800,
        xp: 1300,
        level: 14,
    },
    'golden-jackal': {
        ...BOSS,
        id: 'golden-jackal',
        name: 'Chacal d’Or',
        bodyKey: 'body.golden-jackal',
        tilesPerSecond: 3.5,
        health: 6000,
        damage: 26,
        attackIntervalMs: 1500,
        xp: 2400,
        level: 18,
    },
    'frost-giant': {
        ...BOSS,
        id: 'frost-giant',
        name: 'Géant de Givre',
        bodyKey: 'body.frost-giant',
        tilesPerSecond: 2.5,
        health: 7500,
        damage: 36,
        attackIntervalMs: 2000,
        xp: 3600,
        level: 23,
    },
};
//# sourceMappingURL=boss-mobs.js.map